import { selectFromRouteSolutionDto } from '../../models';
import RouteBreakdownTimelineOrderQuery from './RouteBreakdownTimelineOrderQuery';

export default selectFromRouteSolutionDto()
  .id
  .load
  .stopsCount
  .distance
  .workingTime
  .distance
  .polyline
  .finished
  .violations(violation => violation
    .type)
  .routeTimeline(routeTimeline => routeTimeline
    .id
    .routeSolutionId
    .eventType
    .eventUuid
    .orderUuid
    .reattemptEventUuid
    .sequence
    .stopSequence
    .startTime
    .endTime
    .isArrived
    .isDeparted
    .constraints(routeTimelineConstraints => routeTimelineConstraints
      .address
      .latitude
      .longitude)
    .logs(log => log
      .status
      .date
      .eventUuid)
    .violations(violation => violation
      .id
      .type
      .value)
    .orders(RouteBreakdownTimelineOrderQuery)
    .eta(eta => eta
      .expectedArrivalTime
      .expectedFinishTime
      .originalArrivalTime
      .originalFinishTime
      .actualArrivalTime
      .actualFinishTime)
    .eventSummary(es => es.status.exception))
  .toString();
